import React from "react";
import { Bar } from "react-chartjs-2";

const SalesByMenuItemChart = ({ data }) => {
  const menuSalesComparison = data?.menuSalesComparison;
  if (!menuSalesComparison) return null;

  const labels = menuSalesComparison.map((entry) => entry.name);
  const currentData = menuSalesComparison.map((entry) => entry.current);
  const previousData = menuSalesComparison.map((entry) => entry.previous);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Current Range",
        data: currentData,
        backgroundColor: "#4CAF50",
      },
      {
        label: "Previous Range",
        data: previousData,
        backgroundColor: "#9E9E9E",
      },
    ],
  };

  const options = {
    indexAxis: "y",
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Sales by Menu Item (Compared to Previous Range)",
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.raw || 0;
            return `${context.dataset.label}: ₱${value.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          callback: (val) => `₱${val.toLocaleString()}`,
        },
      },
    },
  };

  const BAR_HEIGHT = 30;
  const OVERHEAD = 80;
  const containerHeight = labels.length * BAR_HEIGHT + OVERHEAD;

  return (
    <div style={{ height: containerHeight, overflowY: "auto" }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default SalesByMenuItemChart;
